import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import CircularProgress from 'material-ui/CircularProgress';
import Pagination from 'components/Libs/Pagination';
import TextField from 'material-ui/TextField';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';

/**
 * 
 * @param {{
 *  annotations: any[],
 *  annotationsLoaded: boolean,
 * }} props 
 * @returns 
 */
const AnnotationsList = (props) => {
    const [rowsPerPage] = useState([10, 20, 30]);
    const [rows, setRows] = useState([]);
    const [numberOfRows, setNumberOfRows] = useState(10);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(undefined);
    const [annotations, setAnnotations] = useState(props.annotations);
    const [searchText, setSearchText] = useState('');

    useEffect(() => {
        if (props.annotations.length) {
            setAnnotations(props.annotations);
            setTotal(props.annotations.length);
            handleUpdateRow({ annotations: props.annotations, numberOfRows, page });
        }
    }, [props.annotations]);

    const filterAnnotations = (searchArray, _searchText) => {
        _searchText = _searchText.toLowerCase();

        return searchArray.filter((annotation) => {
            if (annotation.features) {
                if (annotation.features.rule && annotation.features.rule.toLowerCase().includes(_searchText)) { return true; }

                if (annotation.features.majorType && annotation.features.majorType.toLowerCase().includes(_searchText)) { return true; }

                if (annotation.features.string && annotation.features.string.toLowerCase().includes(_searchText)) { return true; }
            }

            if (annotation.type && annotation.type.toLowerCase().includes(_searchText)) {
                return true;
            }

            if (annotation.id) {
                const id = annotation.id + '';
                if (id.includes(_searchText)) {
                    return true;
                }
            }

            return false;
        });
    };

    const changeRowsByPagination = (state) => {
        const elementsOnPage = state.numberOfRows;
        const offset = state.page - 1;
        const from = offset * elementsOnPage;
        const to = (offset * elementsOnPage) + elementsOnPage;

        return (state.annotations || props.annotations).slice(from, to);
    };

    const handleUpdateRow = (newState) => {
        const updatedRows = changeRowsByPagination(newState);
        setNumberOfRows(newState.numberOfRows);
        setPage(newState.page);
        setRows(updatedRows);
    };

    const handleSearch = (e) => {
        const filteredAnnotations = filterAnnotations(props.annotations, e.target.value);
        setAnnotations(filteredAnnotations);
        setTotal(filteredAnnotations.length);
        handleUpdateRow({ annotations: filteredAnnotations, numberOfRows, page: 1 });
    };

    const renderComponent = (
        <div className='annotations-list-b'>
            <div>
                <CircularProgress
                    className={props.annotationsLoaded ? 'hidden' : ''}
                    style={{
                        position: 'absolute',
                        left: '50%',
                        top: '50%',
                        transform: 'translate(-50%, -50%)',
                    }}
                />
            </div>

            <div className={props.annotationsLoaded ? 'navigation' : 'hidden'}>
                <div className='navigation-arrows'>
                    <Pagination
                        total={annotations.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        numberOfRows={numberOfRows}
                        updateRows={handleUpdateRow}
                    />
                </div>

                <div className='navigation-search'>
                    <TextField
                        hintText='Search'
                        hintStyle={{ fontSize: 12 }}
                        style={{ fontSize: 12 }}
                        onChange={handleSearch}
                    />
                </div>

                <div className='navigation-info'>
                    Total annotations: {annotations.length}
                </div>
            </div>

            <div className={props.annotationsLoaded ? 'annotations-table' : 'hidden'}>
                <Table selectable={false}>
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow style={{ height: '28px' }}>
                            <TableHeaderColumn style={{ padding: '0 24px', height: '28px' }}>Value</TableHeaderColumn>
                            <TableHeaderColumn style={{ padding: '0 24px', height: '28px' }}>Rule</TableHeaderColumn>
                            <TableHeaderColumn style={{ padding: '0 24px', height: '28px' }}>Type</TableHeaderColumn>
                            <TableHeaderColumn style={{ padding: '0 24px', height: '28px' }}>MajorType</TableHeaderColumn>
                            <TableHeaderColumn style={{ padding: '0 24px', height: '28px' }}>id</TableHeaderColumn>
                        </TableRow>
                    </TableHeader>

                    <TableBody displayRowCheckbox={false}>
                        {
                            rows.map((annotation, i) => (
                                <TableRow style={{ height: '28px' }} key={i}>
                                    <TableRowColumn style={{ padding: '0 24px', height: '28px' }}>{annotation.features.string}</TableRowColumn>
                                    <TableRowColumn style={{ padding: '0 24px', height: '28px' }}>{annotation.features.rule}</TableRowColumn>
                                    <TableRowColumn style={{ padding: '0 24px', height: '28px' }}>{annotation.type}</TableRowColumn>
                                    <TableRowColumn style={{ padding: '0 24px', height: '28px' }}>{annotation.features.majorType}</TableRowColumn>
                                    <TableRowColumn style={{ padding: '0 24px', height: '28px' }}>{annotation.id}</TableRowColumn>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </div>
        </div>
    );

    return (
        <div>
            {renderComponent}
        </div>
    );
};

export default AnnotationsList;

// export default connect(
//     (state, ownProps) => ({
//         // annotations: state.annotations.items || ownProps.annotations,
//         // isLoaded: state.annotations.isLoaded,
//         // error: state.annotations.error,
//         // isError: state.annotations.isError,
//     }),
//     null,
// )(AnnotationsList);



// WEBPACK FOOTER //
// ./app/components/Letters/common/AnnotationsList.jsx